import { WindowManagerConfig, WindowProps } from './types';

export function configToWindowProps(config: WindowManagerConfig): WindowProps[] {
  return config.windows
    .map((window, index) => 
      ({ focus: index == 0, ...window })
    )
}
